import React, { Component } from 'react';
import { View, TouchableHighlight } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import Avatar from '../Avatar';

import styles from './ContactItem.Styles';

class ContactItem extends Component {
  render() {
    const { containerStyle, avatarPlaceholder, title, phoneNumber, onPress, theme, disabled } =
      this.props;

    return (
      <TouchableHighlight
        onPress={onPress}
        disabled={disabled}
        underlayColor={theme?.colors?.picker?.dropdownActiveItem}
      >
        <View style={[styles.itemContainer(theme), containerStyle]}>
          <View style={styles.leftElementContainer}>
            <Avatar placeholder={avatarPlaceholder} />
          </View>
          <View style={styles.rightSectionContainer}>
            <View style={styles.mainTitleContainer}>
              {title ? (
                <>
                  <VFText i18nKey={title} style={styles.titleStyle(theme)} />
                  <VFText i18nKey={phoneNumber} style={styles.descriptionStyle(theme)} />
                </>
              ) : (
                <VFText i18nKey={phoneNumber} style={styles.titleStyle(theme)} />
              )}
            </View>
          </View>
        </View>
      </TouchableHighlight>
    );
  }
}

ContactItem.propTypes = {
  avatarPlaceholder: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  phoneNumber: PropTypes.string,
  onPress: PropTypes.func,
  disabled: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  containerStyle: ViewPropTypes.style,
};

export default withTheme(ContactItem);
